"use client";
import { useEffect } from "react";
import { useModalContext } from "@/contexts/ModalProvider";
import { useMonarchData } from "@/monarch/MonarchResolver";
import type { MultiCartTestResult } from "@/monarch/rules/multiCart/types";
import CartModal from "../CartModal";
import { defaultData } from "./constants";

export default function AddToCartModal() {
  const {
    showAddToCart,
    handleContinueToCheckout,
    setAddedToCartModalEnabled,
  } = useModalContext();
  const testResult = useMonarchData<MultiCartTestResult>("useMultiCart");

  useEffect(() => {
    if (testResult?.data?.addToCartModal?.enabled) {
      setAddedToCartModalEnabled(true);
    }
  }, [setAddedToCartModalEnabled, testResult]);

  if (!showAddToCart || !testResult?.data?.addToCartModal) {
    return null;
  }
  const { addToCartModal } = testResult.data;

  const subHeader = addToCartModal.modalSubHeader ? (
    addToCartModal.modalSubHeader
  ) : (
    <span>
      Explore more or go to{" "}
      <button
        className="underline"
        onClick={() => {
          handleContinueToCheckout();
        }}
      >
        your cart
      </button>{" "}
      to checkout and start learning
    </span>
  );

  return (
    <CartModal
      modalData={addToCartModal}
      defaultData={defaultData}
      subHeader={subHeader}
    />
  );
}
